import { render } from "./App.vue?vue&type=template&id=b4708398"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b4708398&lang=css"

import exportComponent from "F:\\VSC\\Projects\\Webdev-Redo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__